import { createContext, useContext, type Context, type Provider } from 'react';

// Make sure to add any new exports to src/provider/index.ts!
export const ICONOGRAPHY_REFRESH = 'iconography-refresh-early-adoption-2025-06';

type IFeaturePreviewContext = {
	[key in string]?: boolean;
};

// Add more feature flags (with their default values), as needed
export const FeaturePreviewContext: Context<IFeaturePreviewContext> =
	createContext<IFeaturePreviewContext>({
		[ICONOGRAPHY_REFRESH]: false,
	});

export const useFeaturePreviewContext = (): IFeaturePreviewContext =>
	useContext(FeaturePreviewContext);

export const FeaturePreviewProvider: Provider<IFeaturePreviewContext> =
	FeaturePreviewContext.Provider;
